import { Button, Col, Row, Typography } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LiveIcon from "../../../assets/icons/live-icon.svg";
import BellImg from "../../../assets/images/bell.webp";
import NoVideoPresentationComponent from "../../../components/discover/creator/NoVideoPresentationComponent";
import RenewPresentationComponent from "../../../components/discover/creator/RenewPresentationComponent";
import { PAYMENT_TYPES } from "../../../helpers/constant";
import { IUserSettings } from "../../../helpers/types";
import useFetchProfileEvent from "../../../hooks/userHooks/useFetchProfileEvent";
import liveUtil from "../../../utls/LiveUtil";

interface Props {
  isMyProfile: boolean;
  username: string;
  creatorId: string;
  userSettings: IUserSettings | null;
}
const ProfileEvent: React.FC<Props> = ({ isMyProfile, username, creatorId, userSettings }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { scheduledEvent } = useFetchProfileEvent(creatorId, isMyProfile);

  const onClickGetTicket = () => {
    if (!scheduledEvent) return;
    navigate(`/fan/payment?creatorId=${creatorId}&type=${PAYMENT_TYPES.LIVE}&liveId=${scheduledEvent._id}&redirectUrl=p/${username}`);
  };

  const onClickJoinLive = () => {
    if (!scheduledEvent || !scheduledEvent.isStreaming) return;

    if (scheduledEvent.streamType === "broadcast") {
      navigate(`/fan/live-broadcast/${scheduledEvent._id}`);
    } else {
      navigate(`/fan/live/${scheduledEvent._id}`);
    }
  };

  const onClickLiveEventDetails = () => {
    if (!scheduledEvent && scheduledEvent!.isStreaming) return;
    navigate(`/fan/event/${scheduledEvent?._id}`);
  };

  const displayActionBtn = () => {
    if (!isMyProfile) {
      if (!scheduledEvent?.isPaymentVerified) {
        return (
          <Button className="editLiveButton" onClick={onClickGetTicket}>
            {t("take-ticket")}
          </Button>
        );
      } else {
        const isLive = scheduledEvent?.isStreaming === true;
        return (
          <Button className="editLiveButton" onClick={isLive ? onClickJoinLive : onClickLiveEventDetails}>
            {t(isLive ? "join" : "view-details")}
          </Button>
        );
      }
    } else {
      const liveStartTime = dayjs(scheduledEvent?.scheduleData?.dateTime) as Dayjs;
      const timeNow = dayjs();
      if (liveStartTime.isAfter(timeNow)) {
        return (
          <Button
            className="editLiveButton"
            onClick={() => {
              navigate(`/creator/live/event/detail/${scheduledEvent!._id}`);
            }}
          >
            {t("edit")}
          </Button>
        );
      } else if (liveStartTime.isBefore(timeNow.add(10, "minute"))) {
        return (
          <Button
            className="editLiveButton"
            onClick={() => {
              if (scheduledEvent?.streamType === "broadcast") {
                navigate(`/creator/live/broadcast/${scheduledEvent._id}`);
              } else {
                navigate(`/creator/live/publish/${scheduledEvent?._id}`);
              }
            }}
          >
            {t("start")}
          </Button>
        );
      } else {
        return null;
      }
    }
  };

  return (
    <>
      {!scheduledEvent ? null : (
        <Row className="editLive-container mb-20 mt-10">
          <Col className="editLive-content">
            <Row>
              <Typography.Text className="editLive-title mt-5">
                <img src={LiveIcon} width={30} alt="" />{" "}
                {liveUtil.getScheduleDateTimeStringForProfile(t, scheduledEvent.scheduleData?.dateTime || "")}
              </Typography.Text>
            </Row>
            <Row>
              <Typography.Text className="editLive-description">{isMyProfile ? t("modify-cancel-live") : t("take-ticket-live")}</Typography.Text>
            </Row>
            <Row className="w-full">{displayActionBtn()}</Row>
          </Col>
          <Col className="editLive-image">
            <img src={BellImg} width={120} alt="" />
          </Col>
        </Row>
      )}
      {isMyProfile && !scheduledEvent?.scheduleData?.dateTime && userSettings && (
        <>{userSettings?.expiredDiscovers ? <RenewPresentationComponent /> : !userSettings?.hasDiscovers ? <NoVideoPresentationComponent /> : null}</>
      )}
    </>
  );
};

export default ProfileEvent;
